"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _pclnDesignSystem = require("pcln-design-system");

var _Label = _interopRequireDefault(require("../../text/Label"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Select(_ref) {
  var className = _ref.className,
      color = _ref.color,
      label = _ref.label,
      value = _ref.value,
      options = _ref.options,
      children = _ref.children,
      onChange = _ref.onChange;
  return _react["default"].createElement(_Label["default"], {
    className: className
  }, label, _react["default"].createElement(_pclnDesignSystem.Select, {
    color: color,
    value: value,
    onChange: onChange,
    mt: label ? 2 : 0
  }, children, options && options.map(function (_ref2) {
    var name = _ref2.name,
        value = _ref2.value;
    return _react["default"].createElement("option", {
      key: name,
      value: value
    }, name);
  })));
}

Select.displayName = 'Select';
Select.propTypes = {
  className: _propTypes["default"].string,
  color: _propTypes["default"].string,
  label: _propTypes["default"].string,
  value: _propTypes["default"].string,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].string.isRequired
  })),
  children: _propTypes["default"].node,
  onChange: _propTypes["default"].func
};
Select.defaultProps = {
  className: '',
  color: 'primary'
};
var _default = Select;
exports["default"] = _default;